module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./LookGoodsHistoryView.js"));
	}, "LookGoodsHistoryView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LookGoodsHistoryView!./src/pages/Promote/BusinessCard/LookGoodsHistory/LookGoodsHistoryView.js
// module id = 1638
// module chunks = 418